// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__yB5aQ","pageButton":"Pagination_pageButton__qxy11","pageButtonActive":"Pagination_pageButtonActive__-f7R1"};